import T from "../theme/colors";

export default function ComingSoon({ title, subtitle, icon: Icon }) {
  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", minHeight: 420, padding: 24,
    }}>
      <div style={{
        width: 64, height: 64, borderRadius: 16,
        background: "var(--primary-light)",
        border: `1px solid var(--primary-dim)`,
        display: "flex", alignItems: "center", justifyContent: "center",
        marginBottom: 18,
      }}>
        <Icon size={26} style={{ color: "var(--primary)" }} />
      </div>
      <h2 style={{
        fontSize: 20, fontWeight: 600, color: "var(--text-0)",
        marginBottom: 8, fontFamily: "var(--font-display)",
      }}>
        {title}
      </h2>
      <p style={{ fontSize: 15, color: "var(--text-1)", textAlign: "center", maxWidth: 340, lineHeight: 1.7 }}>
        {subtitle || "This module is under development and will be available soon."}
      </p>
      <div style={{ marginTop: 20, display: "flex", gap: 6 }}>
        {["var(--primary)", "var(--accent)", "var(--warn)"].map((c, i) => (
          <span key={i} style={{
            width: 7, height: 7, borderRadius: "50%", background: c,
            animation: `pulse 1.4s ease ${i * 0.25}s infinite`,
            display: "inline-block",
          }} />
        ))}
      </div>
    </div>
  );
}
